/* eslint-disable import/prefer-default-export */
export const mailProcessTemplate = `
<!-- START: Mail Process Template (body-only) -->
<div id="body" style="min-width:100%;Margin:0;padding:0;background-color:#E0E0E0;">
  <div style="background-color:#E0E0E0;">
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" align="center">
      <tbody>
        <tr>
          <td style="font-size:0;line-height:0;background-color:#E0E0E0;" valign="top" align="center">
            <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" align="center">
              <tbody>
                <tr>
                  <td align="center">
                    <table role="presentation" cellpadding="0" cellspacing="0" style="Margin-left:auto;Margin-right:auto;">
                      <tbody>
                        <tr>
                          <td style="width:566px;">
                            <table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;">
                              <tbody>
                                <tr>
                                  <td style="padding:50px 10px 31px 10px;">
                                    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="width:100%;">
                                      <tbody>
                                        <tr>
                                          <td style="overflow:hidden;background-color:#1C2E69;padding:49px 50px;border-radius:18px 18px 0 0;" align="center">
                                            <img style="display:block;border:0;height:auto;width:106px;max-width:100%;" width="106" alt="" src="https://storagesharepointimpar.blob.core.windows.net/appimages/0353c58b-c107-4453-b017-72121780a362.png" />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="overflow:hidden;background-color:#F8F8F8;padding:40px 50px;border-radius:0 0 18px 18px;">
                                            <p style="margin:0;font-family:Albert Sans,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:22px;font-weight:500;font-size:14px;color:#333333;">Estimado/a inversor/a,</p>
                                            <div style="line-height:20px;font-size:1px;">&nbsp;</div>
                                            <p style="margin:0;font-family:Albert Sans,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:22px;font-weight:500;font-size:14px;color:#333333;">Le informamos que se ha generado documentación asociada a una operación en su cuenta de inversión. Encontrará los documentos adjuntos a este correo.</p>
                                            <div style="line-height:20px;font-size:1px;">&nbsp;</div>
                                            <p style="margin:0;font-family:Albert Sans,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:22px;font-weight:500;font-size:14px;color:#333333;">Quedamos a su disposición para cualquier consulta.</p>
                                            <div style="line-height:20px;font-size:1px;">&nbsp;</div>
                                            <p style="margin:0;font-family:Albert Sans,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:22px;font-weight:500;font-size:14px;color:#333333;">Atentamente,</p>
                                            <div style="line-height:10px;font-size:1px;">&nbsp;</div>
                                            <p style="margin:0;font-family:Albert Sans,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:22px;font-weight:500;font-size:14px;color:#333333;">Equipo de Impar Capital</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="width:100%;margin-top:10px;">
                                      <tbody>
                                        <tr>
                                          <td style="padding:0 50px;" align="center">
                                            <p style="margin:0;font-family:Albert Sans,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;line-height:22px;font-weight:500;font-size:12px;color:#888888;text-align:center;">&copy; 2022 IMPAR CAPITAL Inc. All Rights Reserved</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <div style="line-height:50px;font-size:1px;">&nbsp;</div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- END: Mail Process Template -->
`;
